module.exports = __webpack_public_path__ + "static/media/fb.b2e8fb57.svg";